const initLanguageSelector = () => {
	let submit = document.getElementById('navigation-submit-btn')
	let languageSelector = document.getElementById('language-select')
	let textElement = document.getElementById('privacy-text')
	
	submit.setAttribute('disabled', true)
	languageSelector.addEventListener('change', () => {
		document.querySelector('#previous-page span').innerHTML = aeo['translations']['back_button'][languageSelector.value]
		document.querySelector('#navigation-submit-btn span').innerHTML = aeo['translations']['next_button'][languageSelector.value]

		document.querySelectorAll('#privacy-text .language').forEach(el => {
			el.style.display = 'none'
		})
		let text = document.querySelector('#privacy-text .language.language-' + languageSelector.value)
		
		textElement.parentElement.hidden = text.innerHTML.length === 0
		if (textElement.parentElement.hidden)
		{
			submit.setAttribute('disabled', true)
		}
		else
		{
			submit.removeAttribute('disabled')
			text.style.display = 'block'
		}
	})
}

export { initLanguageSelector }